import categoryService from "../services/category.service";
import { toogleErrorMessage, toogleSuccessMessage } from "./alertMessage";
import {
  CATEGORY_BYID_LIST,
  CATEGORY_LIST,
  CATEGORY_LIST_LOADER,
} from "./type";

export const categoryDetails = (search, page, limit) => (dispatch) => {
  dispatch({ type: CATEGORY_LIST_LOADER, payload: true });
  return categoryService.categoryList(search, page, limit).then((resp) => {
    if (resp.status === 200) {
      dispatch({ type: CATEGORY_LIST, payload: resp.data });
    } else {
      dispatch({ type: CATEGORY_LIST_LOADER, payload: null });
    }
    return resp;
  });
};

export const allCategories = () => async (dispatch) => {
  dispatch({ type: CATEGORY_LIST_LOADER, payload: true });
  try {
    const resp = await categoryService.allCategoryList();

    if (resp.status === 200) {
      dispatch({ type: CATEGORY_LIST, payload: resp.data });
    } else {
      dispatch({ type: CATEGORY_LIST_LOADER, payload: false });
    }

    return resp;
  } catch (error) {
    dispatch({ type: CATEGORY_LIST_LOADER, payload: false });
  }
};

export const categoryListDeleteAction = (id) => async (dispatch) => {
  return await categoryService.categoryListDelete(id).then((resp) => {
    if (resp.status === 200) {
      dispatch(toogleSuccessMessage("Category deleted successfully"));
    } else {
      dispatch(
        toogleErrorMessage(
          resp.response.data.message || "Something wen't wrong"
        )
      );
    }
    return resp;
  });
};

export const categoryAddAction = (payload) => async (dispatch) => {
  return await categoryService.categoryAdd(payload).then((resp) => {
    if (resp.status === 200) {
      dispatch(toogleSuccessMessage("Category add successfully"));
    } else {
      dispatch(
        toogleErrorMessage(
          resp.response.data.message || "Something wen't wrong"
        )
      );
    }
    return resp;
  });
};

export const categoryByIdAction = (id) => (dispatch) => {
  return categoryService.getCategoryById(id).then((resp) => {
    if (resp.status === 200) {
      dispatch({ type: CATEGORY_BYID_LIST, payload: resp.data });
    }
    return resp;
  });
};

export const editCategoryAction = (id, payload) => async (dispatch) => {
  return await categoryService.editCategory(id, payload).then((resp) => {
    if (resp.status === 200) {
      dispatch(toogleSuccessMessage("Category updated successfully"));
    } else {
      dispatch(
        toogleErrorMessage(
          resp.response.data.message || "Something wen't wrong"
        )
      );
    }
    return resp;
  });
};

export const uploadFileAction = (payload) => async () => {
  return await categoryService.uploadFile(payload);
};
